

export const FETCH_CONTACT_TITLES_REQUEST = 'contactTitles/FETCH_CONTACT_TITLES_REQUEST';
export const FETCH_CONTACT_TITLES_SUCCESS = 'contactTitles/FETCH_CONTACT_TITLES_SUCCESS';
export const FETCH_CONTACT_TITLES_FAILURE = 'contactTitles/FETCH_CONTACT_TITLES_FAILURE';

export const FETCH_CONTACT_TITLE_REQUEST = 'street/FETCH_CONTACT_TITLE_REQUEST';
export const FETCH_CONTACT_TITLE_SUCCESS = 'street/FETCH_CONTACT_TITLE_SUCCESS';
export const FETCH_CONTACT_TITLE_FAILURE = 'street/FETCH_CONTACT_TITLE_FAILURE';


export const DELETE_CONTACT_TITLE_REQUEST = 'contactTitles/DELETE_CONTACT_TITLE_REQUEST';
export const DELETE_CONTACT_TITLE_SUCCESS = 'contactTitles/DELETE_CONTACT_TITLE_SUCCESS';
export const DELETE_CONTACT_TITLE_FAILURE = 'contactTitles/DELETE_CONTACT_TITLE_FAILURE';


export const CREATE_CONTACT_TITLE_REQUEST = 'contactTitles/CREATE_CONTACT_TITLE_REQUEST';
export const CREATE_CONTACT_TITLE_SUCCESS = 'contactTitles/CREATE_CONTACT_TITLE_SUCCESS';
export const CREATE_CONTACT_TITLE_FAILURE = 'contactTitles/CREATE_CONTACT_TITLE_FAILURE';


export const UPDATE_CONTACT_TITLE_REQUEST = 'contactTitles/UPDATE_CONTACT_TITLE_REQUEST';
export const UPDATE_CONTACT_TITLE_SUCCESS = 'contactTitles/UPDATE_CONTACT_TITLE_SUCCESS';
export const UPDATE_CONTACT_TITLE_FAILURE = 'contactTitles/UPDATE_CONTACT_TITLE_FAILURE';


export const UPDATE_FIELD = 'contactTitles/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'contactTitles/SET_DEFAULT_DATA';
